import React, { CSSProperties, useContext, useCallback, useMemo, MouseEvent } from 'react'
import prettyBytes from 'pretty-bytes'

import RenderContext from './RenderContext'

import {
  ILayout_Render,
  ILayout_Cell_Props_File,
} from '../types/layout'

import {
  isImageExtension,
} from '../utils/file'

import {
  StorageFile,
} from '../utils/storage'

/*

  RENDER

*/

const getStyles: {
  (props?: any): Record<string, CSSProperties>,
} = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  caption: {
    marginTop: '10px',
    width: '100%',
    fontSize: '9pt',
    color: '#666',
    textAlign: 'center',
  },
  mediaImage: {
    maxWidth: '40px',
    maxHeight: '40px',
    border: '1px solid #000',
  },
  smallText: {
    fontSize: '0.9em',
    color: '#999',
  },
  link: {
    textDecoration: 'none',
  },
  title: {
    color: '#0000ff',
    textDecoration: 'underline',
  },
  block: {
    marginRight: '8px',
  },
})

const FileComponent: ILayout_Render<ILayout_Cell_Props_File> = ({
  cell,
}) => {
  const {
    file,
    title,
  } = cell.data
  const styles = getStyles()
  const {
    project,
    token,
    disableLinks,
    options,
  } = useContext(RenderContext)
  const url = useMemo(() => {
    if(!file) return ''
    return StorageFile(file, token).url({
      breakCache: options.breakImageCache,
    })
  }, [
    project,
    token,
    file,
    options,
  ])
  const onClick = useCallback((e: MouseEvent) => {
    if(!disableLinks) return
    e.preventDefault()
    e.stopPropagation()
  }, [
    disableLinks,
  ])

  const data = useMemo(() => {
    if(!file) return {}
    
    const storageFile = StorageFile(file, token)

    let icon = null

    if(storageFile.isImage() && storageFile.mediaLink()) {
      icon = (
        <div>
          <img style={ styles.mediaImage } src={ storageFile.mediaLinkUrl() } />
        </div>
      )
    }
    else {
      icon = (
        <span className={`fiv-viv fiv-size-md fiv-icon-${storageFile.extension()}`}></span>
      )
    }

    return {
      name: title || storageFile.displayName(),
      icon,
      size: file.meta.size && isNaN(parseInt(file.meta.size)) ? '' : (
        <div style={ styles.smallText }>
          { prettyBytes(parseInt(file.meta.size || '0')) }
        </div>
      ),
    }
  }, [
    file,
    token,
  ])

  if(!url) return null

  return (
    <a
      href={ url }
      target="blank"
      style={ styles.link }
      onClick={ onClick }
    >
      <div style={ styles.container }>
        <div style={ styles.block }>
          { data.icon }
        </div>
        <div style={ styles.block }>
          { data.name }
        </div>
        <div style={ styles.block }>
          { data.size }
        </div>
      </div>
    </a>
  )
}

export default FileComponent 